import React from "react";
import { Row, Col } from "react-bootstrap";
import "./AnniversaryUser.css";

function AnniversaryUser({
  id,
  firstName,
  lastName,
  profileName,
  profileNameEnglish,
  language,
  day,
  years,
}) {
  return (
    <Col className="anniversary-user">
      <Row className="justify-content-center align-items-center">
        <Col lg={1} className="center">
          <h4>{day}</h4>
        </Col>
        <Col lg={9}>
          <h6>{firstName + " " + lastName}</h6>
          <p>{language === "es" ? profileName : profileNameEnglish}</p>
        </Col>
        <Col lg={2}>
          <h6>
            {years} {language === "es" ? "años" : "years"}
          </h6>
        </Col>
      </Row>
    </Col>
  );
}

export default AnniversaryUser;
